import { FC } from 'react';

import { PaginationController } from '../../../../../components/pagination-controller/index';
import { itemsToFetchMap } from './event-table-types.types';

export type PaginationItemProps = {
  currentPage: number;
  handleChangeCurrentPage: (page: number) => void;
  handleFetchAmountChange: (items: number) => void;
  itemsCount: number;
  itemsToFetch: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  totalPages: number;
};

export const PaginationItem: FC<PaginationItemProps> = ({
  handleFetchAmountChange,
  itemsToFetch,
  currentPage,
  handleChangeCurrentPage,
  totalPages,
  itemsCount,
}) => {
  return (
    <PaginationController
      className="shrink-0"
      currentPage={currentPage}
      itemsCount={itemsCount}
      itemsToFetch={itemsToFetch}
      itemsToFetchMap={itemsToFetchMap}
      onClick={handleChangeCurrentPage}
      onFetchAmountChange={handleFetchAmountChange}
      totalPages={totalPages}
    />
  );
};
